module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/lion.37aaaa62.png";